import './bootstrap';

import bulmaCarousel from 'bulma-carousel';
window.bulmaCarousel = bulmaCarousel;
